export const isEmptyValue = (value?: unknown): boolean => value === "" || value === null || value === undefined;
